/* Copy da trilha de auditoria (ADR-0708/0713): header, chip de escopo por alvo e o rodapé de
   paginação ("N carregados" + "Carregar mais"). Filtros (`AuditFilters`) são componente externo —
   fora do escopo desta área. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface AuditContent {
  readonly title: string;
  readonly description: string;
  readonly loadFailed: string;
  readonly filteringByTarget: string;
  readonly removeTargetFilter: string;
  /** "N carregados" — contador da página acumulada, não do total da trilha. */
  readonly loadedCount: (count: number) => string;
  readonly loadMore: string;
}

export const AUDIT_CONTENT: Bilingual<AuditContent> = {
  'pt-BR': {
    title: 'Auditoria',
    description:
      'Trilha imutável das ações administrativas — quem fez o quê, quando e em qual alvo.',
    loadFailed: 'Falha ao carregar a trilha de auditoria.',
    filteringByTarget: 'Filtrando pelo alvo:',
    removeTargetFilter: 'Remover filtro de alvo',
    loadedCount: (count) => `${count} carregados`,
    loadMore: 'Carregar mais',
  },
  'en-US': {
    title: 'Audit',
    description:
      'Immutable trail of administrative actions — who did what, when, and on which target.',
    loadFailed: 'Failed to load the audit trail.',
    filteringByTarget: 'Filtering by target:',
    removeTargetFilter: 'Remove target filter',
    loadedCount: (count) => `${count} loaded`,
    loadMore: 'Load more',
  },
};

export const useAuditContent = (): AuditContent => useBilingual(AUDIT_CONTENT);
